import { render, staticRenderFns } from "./organization-question-set.vue?vue&type=template&id=6e6c35cb&scoped=true"
import script from "./organization-question-set.vue?vue&type=script&lang=js"
export * from "./organization-question-set.vue?vue&type=script&lang=js"
import style0 from "./organization-question-set.vue?vue&type=style&index=0&id=6e6c35cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c35cb",
  null
  
)

export default component.exports